import { render, staticRenderFns } from "./ManageDrivers.vue?vue&type=template&id=240cbb3e&scoped=true&"
import script from "./ManageDrivers.vue?vue&type=script&lang=js&"
export * from "./ManageDrivers.vue?vue&type=script&lang=js&"
import style0 from "./ManageDrivers.vue?vue&type=style&index=0&id=240cbb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cbb3e",
  null
  
)

export default component.exports